<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['配对会列表', action + '配对会列表']"/>
    <div class="detail-content common-padding">
      <el-card class="box-card exhibition-card">
        <el-row type="flex" justify="center">
          <el-col :span="18">
            <el-form ref="form" :model="form" :rules="rules" label-width="140px" class="exhibition-form">
              <ul class="exhibition-box">
                <li>
                  <el-form-item label="标题：" prop="title">
                    <el-input class="right-input" v-model="form.title" placeholder="标题20个汉字最多"></el-input>
                  </el-form-item>
                  <el-form-item label="封面海报地址：" prop="posterUrl">
                    <signImage @success="getPosterUrl" :img="posterUrlList"/>
                  </el-form-item>
                  <el-form-item label="简介：" prop="introduce">
                    <el-input v-model.trim="form.introduce" type="textarea" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="开始时间：" prop="startTime">
                    <el-date-picker style="width: 100%" v-model="form.startTime" type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="结束时间：" prop="endTime">
                    <el-date-picker style="width: 100%" v-model="form.endTime" type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="类型：" prop="activityType">
                    <el-radio-group v-model="form.activityType" @change="typeChange">
                      <el-radio label="1">品牌</el-radio>
                      <el-radio label="2">展商</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="报名限制：" prop="">
                    <div v-if="form.activityType === '1'">
                      <ul class="enroll-ul">
                        <li>品类：</li>
                        <li>
                          <el-radio-group v-model="form.category" @change="brandCategoryChange">
                            <el-radio label="2">不限</el-radio>
                            <el-radio label="1">限制,请选择</el-radio>
                          </el-radio-group>
                          <div class="no-limit" v-if="form.category === '1'">
                            <div class="limit-flex">
                              <div>
                                <el-checkbox v-model="rhBrand" @change="rhBrandChange">日化品牌</el-checkbox>
                              </div>
                              <div>一级品类：</div>
                              <div class="limit-tree">
                                <div class="tree-box">
                                  <el-tree ref="rhBrandTree" node-key="id" :data="rhBrandData" :props="defaultProps"
                                           :default-checked-keys="rhBrandKeys" :show-checkbox="rhBrand"
                                           @check="getRhBrandList"></el-tree>
                                </div>
                              </div>
                            </div>
                            <div class="limit-flex">
                              <div>
                                <el-checkbox v-model="majorBrand" @change="majorBrandChange">专业品牌</el-checkbox>
                              </div>
                              <div>一级品类：</div>
                              <div class="limit-tree">
                                <div class="tree-box">
                                  <el-tree ref="majorBrandTree" node-key="id" :data="majorBrandData" :props="defaultProps"
                                           :default-checked-keys="majorBrandKeys" :show-checkbox="majorBrand"
                                           @check="getMajorBrandList"></el-tree>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <ul class="enroll-ul">
                        <li>数量限制：</li>
                        <li class="enroll-price">
                          <div>
                            <el-radio-group v-model="form.quantity" @change="brandNumberChange">
                              <el-radio label="2">不限</el-radio>
                              <el-radio label="1">限制,请选择</el-radio>
                            </el-radio-group>
                          </div>
                          <div class="limit-price" v-if="form.quantity === '1'">
                            <div>每个商家限制：</div>
                            <el-input v-model.number="form.brandQuantity" size="small"></el-input>
                            <div>个品牌</div>
                          </div>
                        </li>
                      </ul>
                      <ul class="enroll-ul area-ul">
                        <li>原产地：</li>
                        <li class="enroll-price">
                          <div>
                            <el-radio-group v-model="form.placeOrigin" @change="brandAreaChange">
                              <el-radio label="2">不限</el-radio>
                              <el-radio label="1">限制,请选择</el-radio>
                            </el-radio-group>
                          </div>
                          <div class="limit-price" v-if="form.placeOrigin === '1'">
                            <div>原产地：</div>
                            <div class="limit-tree">
                              <div class="tree-box">
                                <el-tree ref="brandOriginOptionsTree" node-key="id" :data="brandOriginOptions"
                                         :props="defaultProps" :default-checked-keys="brandOriginOptionsKeys" show-checkbox
                                         @check="getBrandOriginOptionsList"></el-tree>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div v-if="form.activityType === '2'">
                      <ul class="enroll-ul">
                        <li>品类：</li>
                        <li>
                          <el-radio-group v-model="form.exhibitorRestrictions" @change="businessCategoryChange">
                            <el-radio label="2">不限</el-radio>
                            <el-radio label="1">限制,请选择</el-radio>
                          </el-radio-group>
                          <div class="no-limit" v-if="form.exhibitorRestrictions === '1'">
                            <div class="limit-flex">
                              <div>
                                <el-checkbox v-model="cosmeticRestrictions">日化商家</el-checkbox>
                              </div>
                            </div>
                            <div class="limit-flex">
                              <div>
                                <el-checkbox v-model="professionalRestrictions">专业商家</el-checkbox>
                              </div>
                            </div>
                            <div class="limit-flex">
                              <div>
                                <el-checkbox v-model="factoryBusiness">工厂</el-checkbox>
                              </div>
                              <div>一级品类：</div>
                              <div class="limit-tree">
                                <div class="tree-box">
                                  <el-tree ref="factoryBusinessTree" node-key="id" :data="factoryOneCategoryList"
                                           :props="defaultProps" :default-checked-keys="factoryOneCategoryListKeys"
                                           :show-checkbox="factoryBusiness"
                                           @check="getFactoryOneCategoryListKeys"></el-tree>
                                </div>
                              </div>
                            </div>
                            <div class="limit-flex">
                              <div>
                                <el-checkbox v-model="serviceBusiness">服务商</el-checkbox>
                              </div>
                              <div>一级品类：</div>
                              <div class="limit-tree">
                                <div class="tree-box">
                                  <el-tree ref="serviceBusinessTree" node-key="id" :data="providerCategoryList"
                                           :props="defaultProps" :default-checked-keys="providerCategoryListKeys"
                                           :show-checkbox="serviceBusiness" @check="getProviderCategoryListKeys"></el-tree>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </el-form-item>
                  <el-form-item label="驳回原因：" v-if="form.status === '3'">
                    <p class="reject-text">{{ form.reason }}</p>
                  </el-form-item>
                </li>
              </ul>
              <div class="info-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">保 存</el-button>
              </div>
            </el-form>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <el-dialog width="70%" class="special-list-dialog" title="特邀商家列表" :show-close="false"
               :visible.sync="companyVisible">
      <!--      <el-button class="btns-add" icon="el-icon-plus" size="medium" @click="add">添加</el-button>-->
      <el-table
          :data="tableData"
          :max-height="tableHeight"
          style="width: 100%"
          border
      >
        <el-table-column type="index" width="80px" align="center" label="序号"></el-table-column>
        <el-table-column prop="companyName" align="center" label="名称"></el-table-column>
        <el-table-column prop="logo" align="center" label="logo">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.logo"
                style="height: 100px"
                :src="scope.row.logo"
                :preview-src-list="[scope.row.logo]"
                fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="type" align="center" label="类型">
          <template slot-scope="scope">
            {{ getType(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="address" align="center" label="地址"></el-table-column>
        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="deleteInfo(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes"
          :total="total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'
// import exhibitionXcUpload from '../../components/exhibitionXcUpload.vue'
import editor from '../../components/editor.vue'
// import signImage from '../../components/signImage.vue'

export default {
  name: 'detail',
  data () {
    return {
      baseURL: this.baseUrl,
      token: sessionStorage.getItem('token'),
      loading: false,
      companyVisible: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      action: '添加',
      id: '',
      fileList: [],
      posterUrlList: [],
      form: {
        meetId: '',
        publicityMap: '',
        ruleDescription: '',
        markingDiagramList: '',
        title: '',
        startTime: '',
        endTime: '',
        registrationStartTime: '',
        registrationEndTime: '',
        specialInvitation: '',
        activityType: '',
        placeOrigin: '',
        enterPort: '',
        domestic: '',
        category: '',
        cosmeticProductCategory: '',
        professionalProductCategory: '',
        factoryProductCategory: '',
        providerProductCategory: '',
        quantity: '',
        companyProductQuantity: '',
        brandProductQuantity: '',
        price: '',
        minimumPrice: '',
        highestPrice: '',
        cosmeticBrandCategory: '',
        professionalBrandCategory: '',
        brandQuantity: '',
        brandOrigin: '',

        exhibitorRestrictions: '',
        cosmeticRestrictions: '',
        professionalRestrictions: '',
        factoryRestrictions: '',
        providerRestrictions: ''
      },
      cosmeticRestrictions: false,
      professionalRestrictions: false,
      areaType1: false,
      areaType2: false,
      rhProduct: false,
      majorProduct: false,
      factoryProduct: false,
      serviceProduct: false,
      isExhibition: false,
      isBrand: false,
      rhBrand: false,
      majorBrand: false,
      rhBusiness: false,
      majorBusiness: false,
      factoryBusiness: false,
      serviceBusiness: false,
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {max: 20, message: '长度在20个字符内', trigger: 'blur'}
        ]
      },
      tableData: [],
      tableHeight: 0,
      publicityMapList: [],
      markingDiagramList: [],
      areaTypeData: [],
      rhBrandData: [],
      majorBrandData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      areaProps: {
        children: 'children',
        label: 'name',
        value: 'id',
        multiple: true
      },
      originOptions: [],
      abroadAreaList: [],
      abroadAreaKeys: [],
      domesticAreaList: [],
      domesticAreaKeys: [],
      rhCategoryList: [],
      rhKeys: [],
      brandCategoryList: [],
      brandKeys: [],
      brandTwoCategoryList: [],
      factoryCategoryList: [],
      factoryKeys: [],
      categoryProps: {
        label: 'name',
        children: 'childList'
      },
      serviceCategoryList: [],
      serviceKeys: [],
      brandOriginOptions: [],
      rhBrandKeys: [],
      majorBrandKeys: [],
      brandOriginOptionsKeys: [],

      factoryOneCategoryList: [],
      providerCategoryList: [],
      factoryOneCategoryListKeys: [],
      providerCategoryListKeys: []
    }
  },
  components: {
    navHeader,
    editor
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 400
    this.action = this.$route.params.type === 'edit' ? '编辑' : '添加'
    this.loading = this.action === '编辑'
    this.id = this.$route.params.id ? this.$route.params.id : ''
    this.form.meetId = this.$route.params.meetId ? this.$route.params.meetId : ''
    this.getPageList()
    this.getProducingAreaList()
    this.getAbroadAreaList()
    this.getDomesticAreaList()
    this.getRhCategoryList()
    this.getBrandCategoryList()
    this.getFactoryCategoryList()
    this.getServiceCategoryList()
    this.getRhBrandData()
    this.getMajorBrandData()
    this.getBrandOriginOptions()
    this.getFactoryOneCategoryList()
    this.getProviderCategoryList()
  },
  mounted () {
    if (this.id) {
      this.getDetail(this.id)
    }
  },
  methods: {
    getDetail (id) {
      this.$http.post('/meetSession/meetSession/getById', {id}).then(res => {
        if (res.data.code === '200') {
          this.form = res.data.data
          this.activityId = this.form.id
          this.publicityMapList = this.form.publicityMap ? this.form.publicityMap.split(',') : []
          this.posterUrlList = this.form.posterUrl ? this.form.posterUrl.split(',') : []
          this.areaType1 = !!this.form.enterPort
          this.areaType2 = !!this.form.domestic
          this.rhProduct = !!this.form.cosmeticProductCategory
          this.majorProduct = !!this.form.professionalProductCategory
          this.factoryProduct = !!this.form.factoryProductCategory
          this.serviceProduct = !!this.form.providerProductCategory
          this.isExhibition = !!this.form.companyProductQuantity
          this.isBrand = !!this.form.brandProductQuantity
          this.abroadAreaKeys = this.form.enterPort ? JSON.parse(this.form.enterPort) : []
          this.domesticAreaKeys = this.form.domestic ? JSON.parse(this.form.domestic) : []
          this.rhKeys = this.form.cosmeticProductCategory ? JSON.parse(this.form.cosmeticProductCategory) : []
          this.brandKeys = this.form.professionalProductCategory ? JSON.parse(this.form.professionalProductCategory) : []
          this.factoryKeys = this.form.factoryProductCategory ? JSON.parse(this.form.factoryProductCategory) : []
          this.serviceKeys = this.form.providerProductCategory ? JSON.parse(this.form.providerProductCategory) : []

          this.rhBrand = !!this.form.cosmeticBrandCategory
          this.majorBrand = !!this.form.professionalBrandCategory
          this.rhBrandKeys = this.form.cosmeticBrandCategory ? JSON.parse(this.form.cosmeticBrandCategory) : []
          this.majorBrandKeys = this.form.professionalBrandCategory ? JSON.parse(this.form.professionalBrandCategory) : []
          this.brandOriginOptionsKeys = this.form.brandOrigin ? JSON.parse(this.form.brandOrigin) : []

          this.cosmeticRestrictions = this.form.cosmeticRestrictions === '1'
          this.professionalRestrictions = this.form.professionalRestrictions === '1'
          this.factoryBusiness = !!this.form.factoryRestrictions
          this.serviceBusiness = !!this.form.providerRestrictions
          this.factoryOneCategoryListKeys = this.form.factoryRestrictions ? JSON.parse(this.form.factoryRestrictions) : []
          this.providerCategoryListKeys = this.form.providerRestrictions ? JSON.parse(this.form.providerRestrictions) : []

          this.loading = false
        }
      }).catch(e => {
        this.loading = false
        this.$message.error(e)
      })
    },
    async getPageList () {
      let {data: res} = await this.$http.post('/boutiqueActivities/boutiqueActivities/getSpecialCompanyList', {
        activityId: this.id,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      }
    },
    add () {

    },
    getType (type) {
      let name = ''
      switch (type) {
        case '1':
          name = '日化品牌展商'
          break
        case '2':
          name = '专业品牌展商'
          break
        case '3':
          name = '工厂展商'
          break
        case '4':
          name = '服务商展商'
          break
        default:
      }
      return name
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    async deleteInfo (id) {
      let {data: res} = await this.$http.post('/boutiqueActivities/boutiqueActivities/deleteSpecialCompany', {id})
      if (res.code === '200') {
        this.$message.success(res.msg)
        await this.getPageList()
      } else {
        this.$message.error(res.msg)
      }
    },
    getBanner (list) {
      this.form.publicityMap = list.join(',')
    },
    setHtml (html) {
      this.form.ruleDescription = html
    },
    getPosterUrl (list) {
      this.form.posterUrl = list.join(',')
    },
    // 类型切换
    typeChange () {
      this.form.placeOrigin = ''
      this.form.category = ''
      this.form.quantity = ''
      this.form.price = ''

      this.form.area = ''
      this.form.total = ''
      this.form.brandCategory = ''
      this.form.brandTotalType = ''
      this.form.areaType = ''
      this.form.businessCategory = ''
    },
    // 产品
    // 产地切换
    areaChange () {
      this.areaType1 = false
      this.areaType2 = false
      this.abroadAreaKeys = []
      this.form.enterPort = ''
      this.domesticAreaKeys = []
      this.form.domestic = ''
    },
    // 产地限制
    isAbroad (val) {
      if (!val) {
        this.abroadAreaKeys = []
        this.form.enterPort = ''
      }
    },
    isDomestic (val) {
      if (!val) {
        this.domesticAreaKeys = []
        this.form.domestic = ''
      }
    },
    // 品类切换
    categoryChange () {
      this.rhProduct = false
      this.majorProduct = false
      this.factoryProduct = false
      this.serviceProduct = false
      this.form.cosmeticProductCategory = ''
      this.form.professionalProductCategory = ''
      this.form.factoryProductCategory = ''
      this.form.providerProductCategory = ''
    },
    rhProductChange () {
      this.form.cosmeticProductCategory = ''
    },
    majorProductChange () {
      this.form.professionalProductCategory = ''
    },
    factoryProductChange () {
      this.form.factoryProductCategory = ''
    },
    serviceProductChange () {
      this.form.providerProductCategory = ''
    },
    // 数量切换
    totalChange () {
      this.isExhibition = false
      this.isBrand = false
      this.form.companyProductQuantity = ''
      this.form.brandProductQuantity = ''
    },
    // 数量限制
    changeExhibition (val) {
      if (!val) this.form.companyProductQuantity = ''
    },
    changeBrand (val) {
      if (!val) this.form.brandProductQuantity = ''
    },
    // 价格限制
    priceChange () {
      this.form.minimumPrice = ''
      this.form.highestPrice = ''
    },
    // 品牌
    // 品类切换
    brandCategoryChange () {
      this.form.rhBrand = false
      this.form.majorBrand = false
    },
    rhBrandChange () {
      this.form.cosmeticBrandCategory = ''
    },
    majorBrandChange () {
      this.form.professionalBrandCategory = ''
    },
    // 数量限制切换
    brandNumberChange () {
      this.form.brandNumber = ''
    },
    // 原产地切换
    brandAreaChange () {
      this.form.brandOrigin = ''
    },
    // 国外地区
    getAbroadAreaList () {
      this.$http
        .get('/boutiqueActivities/boutiqueActivities/getAbroadAreaList')
        .then((res) => {
          if (res.data.code === '200') {
            this.abroadAreaList = [res.data.data]
          }
        })
    },
    getAbroadAreaKeys () {
      this.form.enterPort = this.$refs.abroadAreaTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.abroadAreaTree.getCheckedKeys()) : ''
    },
    // 国内地区
    getDomesticAreaList () {
      this.$http
        .get('/boutiqueActivities/boutiqueActivities/getDomesticAreaList')
        .then((res) => {
          if (res.data.code === '200') {
            this.domesticAreaList = [res.data.data]
          }
        })
    },
    getDomesticAreaKeys () {
      this.form.domestic = this.$refs.domesticAreaTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.domesticAreaTree.getCheckedKeys()) : ''
    },
    // 日化产品品类
    getRhCategoryList () {
      this.$http
        .get('/cosmeticBrand/cosmeticBrand/getBrandCategoryList')
        .then((res) => {
          if (res.data.code === '200') {
            this.rhCategoryList = res.data.data
          }
        })
    },
    // 日化产品回显
    getRhTwoCategoryList () {
      this.form.cosmeticProductCategory = this.$refs.rhCategoryTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.rhCategoryTree.getCheckedKeys()) : ''
    },
    // 专业产品 品类
    getBrandCategoryList () {
      this.$http
        .get('/ProfessionalBrand/professionalBrand/getBrandCategoryList')
        .then((res) => {
          if (res.data.code === '200') {
            this.brandCategoryList = res.data.data
          }
        })
    },
    // 专业产品品类回显
    getBrandTwoCategoryList () {
      this.form.professionalProductCategory = this.$refs.categoryTree.getCheckedKeys() ? JSON.stringify(this.$refs.categoryTree.getCheckedKeys()) : ''
    },
    // 工厂产品品类
    getFactoryCategoryList () {
      this.$http
        .post('/brandCategory/getCategoryByType', {type: '3'})
        .then((res) => {
          if (res.data.code === '200') {
            this.factoryCategoryList = res.data.data
          }
        })
    },
    // 工厂产品品类回显
    getFactoryTwoCategoryList () {
      this.form.factoryProductCategory = this.$refs.factoryTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.factoryTree.getCheckedKeys()) : ''
    },
    // 服务商产品品类
    getServiceCategoryList () {
      this.$http
        .post('/brandCategory/getCategoryByType', {type: '4'})
        .then((res) => {
          if (res.data.code === '200') {
            this.serviceCategoryList = res.data.data
          }
        })
    },
    // 服务商产品品类回显
    getServiceTwoCategoryList () {
      this.form.providerProductCategory = this.$refs.serviceTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.serviceTree.getCheckedKeys()) : ''
    },
    // 日化品牌回显
    getRhBrandList () {
      this.form.cosmeticBrandCategory = this.$refs.rhBrandTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.rhBrandTree.getCheckedKeys()) : ''
    },
    // 专业品牌回显
    getMajorBrandList () {
      this.form.professionalBrandCategory = this.$refs.majorBrandTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.majorBrandTree.getCheckedKeys()) : ''
    },
    // 品牌原产地回显
    getBrandOriginOptionsList () {
      this.form.brandOrigin = this.$refs.brandOriginOptionsTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.brandOriginOptionsTree.getCheckedKeys()) : ''
    },
    // 工厂回显
    getFactoryOneCategoryListKeys () {
      this.form.factoryRestrictions = this.$refs.factoryBusinessTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.factoryBusinessTree.getCheckedKeys()) : ''
    },
    // 服务商回显
    getProviderCategoryListKeys () {
      this.form.providerRestrictions = this.$refs.serviceBusinessTree.getCheckedKeys().length > 0 ? JSON.stringify(this.$refs.serviceBusinessTree.getCheckedKeys()) : ''
    },
    // 原产地
    getProducingAreaList () {
      this.$http
        .get('/cosmeticProduct/cosmeticProduct/getProducingAreaList')
        .then((res) => {
          console.log(res)
          if (res.data.code === '200') {
            this.originOptions = res.data.data
          }
        })
    },
    // 日化品牌一级
    getRhBrandData () {
      this.$http
        .get('/boutiqueActivities/boutiqueActivities/getCosmeticBrandCategoryList')
        .then((res) => {
          console.log(res)
          if (res.data.code === '200') {
            this.rhBrandData = res.data.data
          }
        })
    },
    // 专业品牌一级
    getMajorBrandData () {
      this.$http
        .get('/boutiqueActivities/boutiqueActivities/getProfessionalBrandCategoryList')
        .then((res) => {
          console.log(res)
          if (res.data.code === '200') {
            this.majorBrandData = res.data.data
          }
        })
    },
    // 品牌产地
    getBrandOriginOptions () {
      this.$http
        .get('/boutiqueActivities/boutiqueActivities/getProducingAreaList')
        .then((res) => {
          console.log(res)
          if (res.data.code === '200') {
            this.brandOriginOptions = res.data.data
          }
        })
    },
    // 工厂一级
    getFactoryOneCategoryList () {
      this.$http
        .get('/boutiqueActivities/boutiqueActivities/getFactoryCategoryList')
        .then((res) => {
          console.log(res)
          if (res.data.code === '200') {
            this.factoryOneCategoryList = res.data.data
          }
        })
    },
    // 服务商一级
    getProviderCategoryList () {
      this.$http
        .get('/boutiqueActivities/boutiqueActivities/getProviderCategoryList')
        .then((res) => {
          console.log(res)
          if (res.data.code === '200') {
            this.providerCategoryList = res.data.data
          }
        })
    },
    // 展商
    businessCategoryChange () {
      this.rhBusiness = false
      this.majorBusiness = false
      this.factoryBusiness = false
      this.serviceBusiness = false
    },
    // 取消
    cancel () {
      this.$router.back()
    },
    save () {
      this.$refs.form.validate(val => {
        if (val) {
          this.form.cosmeticRestrictions = this.cosmeticRestrictions ? '1' : '2'
          this.form.professionalRestrictions = this.professionalRestrictions ? '1' : '2'
          let params = JSON.parse(JSON.stringify(this.form))
          let url = ''
          if (this.action === '添加') {
            url = 'meetSession/meetSession/addMeetSession'
          } else {
            url = 'meetSession/meetSession/updateMeetSession'
          }
          this.$http.post(url, params).then(res => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.$router.back()
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(e => {
            console.log(e)
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.exhibition-box {
  width: 100%;
  display: flex;
  overflow: auto;

  > li:first-child {
    width: 750px;
  }

  > li:last-child {
    margin-left: 60px;

    > div {
      width: 780px;
    }
  }

  p {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #aaa
  }

  .rules-text {
    margin-top: 30px;
  }

  .el-form-item {
    margin-bottom: 25px !important;
  }

  .right-input {
    width: 60%;
  }

  .special-box {
    display: flex;
    justify-content: space-between;

    .special-ul {
      width: calc(100% - 160px);
      display: flex;
      font-size: 12px;

      li {
        margin-right: 20px;

        &:first-child {
          display: flex;
        }
      }

      .special-text {
        color: #409EFF;
        cursor: pointer;
      }
    }
  }

  .enroll-ul {
    display: flex;
    margin-bottom: 30px;

    > li:first-child {
      width: 120px;
    }

    .enroll-price {
      display: flex;
      align-items: center;

      .limit-price {
        display: flex;
        margin-left: 40px;
        align-items: center;

        .el-input {
          width: 100px;
          margin: 0 10px;
        }
      }
    }
  }

  .no-limit {
    margin-left: 82px;

    .limit-flex {
      //height: 50px;
      display: flex;
      align-items: center;

      > div:first-child {
        width: 100px;
        margin-right: 30px;
      }

      .limit-tree {
        min-width: 200px;
      }

      .limit-input {
        .el-input {
          width: 80px;
          height: 30px;
          margin: 0 10px;
        }
      }
    }
  }

  .area-ul {
    align-items: center;
  }
}

</style>
<style lang="less">
.exhibition-editor {
  .w-e-toolbar {
    display: none !important;
  }

  .w-e-text {
    border-top: 1px solid #ccc;
  }
}

.exhibition-form {
  .el-form-item__label {
    font-size: 16px !important;
    font-weight: 600;
    color: #aaa
  }
}

.special-list-dialog .el-dialog {
  margin-top: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/meetSession/detail.vue